import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Table, Button, DatePicker, Checkbox, Select, Collapse,
  notification,
  Drawer,
} from 'antd';
import dayjs from 'dayjs';
import { EditFilled, LoadingOutlined, CaretRightOutlined } from '@ant-design/icons';
import { QUANTITY } from '@Apis/constants';
import PurchaseOrderActions from '@Actions/purchaseOrderActions';
import DocConfigActions from '@Actions/docConfigActions';
import H3Image from '@Uilib/h3Image';
import imageDefault from '@Images/icons/imageDefault.png';
import Helpers from '@Apis/helpers';
import AddressSelector from '@Components/Common/FormUtils/AddressSelecter';

import './style.scss';
import H3Text from '@Uilib/h3Text';
import H3FormInput from '@Uilib/h3FormInput';
import SelectPaymentTerm from '@Components/Common/SelectPaymentTerm';
import HideValue from '../../../Common/RestrictedAccess/HideValue';
import CustomFieldHelpers from '@Helpers/CustomFieldHelpers';
import CustomFieldV3 from '@Components/Common/CustomFieldV3';
import PRZSelect from '../../../Common/UI/PRZSelect';
import DocumentNumberSeqInput from '../../../Admin/Common/DocumentNumberSeqInput';
const { Panel } = Collapse;

/**
 * @param value
 */
class PRVerifyPurchaseOrders extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);

    const { priceMasking } = props;
    const { isDataMaskingPolicyEnable, isHideCostPrice, isHideSellingPrice } = priceMasking;
    this.state = {
      columns: [
        {
          title: '',
          width: '60px',
          render: (text, record) => (
            record?.product_sku_info?.assets?.[0]?.url
              ? (
                <H3Image
                  src={record?.product_sku_info?.assets[0].url}
                  className="prod-table__image"
                  style={{ width: '40px', height: '40px' }}
                />
              )
              : <H3Image src={imageDefault} className="prod-table__image prod-table__image__default" style={{ width: '40px', height: '40px' }} />
          ),
        },
        {
          title: 'Product',
          render: (record) => <div>{record?.product_sku_name}</div>,
        },
        {
          title: 'Quantity',
          render: (record) => <div>{`${QUANTITY(record?.quantity, record?.uom_info?.precision)} ${record?.uom_info?.uqc?.toProperCase() || ''}`}</div>,

        },
        {
          title: 'Unit Price',
          render: (record) => ((isDataMaskingPolicyEnable && isHideCostPrice) ? <HideValue showPopOver popOverMessage={"You don't have access to unit price"} /> : this.props.MONEY(record?.unitPrice)),
          width: '12%',
        },
        {
          title: 'Tax',
          render: (record) => `${record?.tax_value ? record?.tax_value : 0}%`,
          width: '10%',
        },
        {
          title: 'Total',
          render: (record) => ((isDataMaskingPolicyEnable && isHideCostPrice) ? <HideValue showPopOver popOverMessage={"You don't have access to unit price"} /> : this.props.MONEY(this.getLineTotal(record) || '0')),
        },

      ],
    };
  }

  componentDidMount() {
    const { tenantSellerPRItems, getDocConfig } = this.props;

    const tenantIdsSet = new Set();

    Object.values(tenantSellerPRItems)?.forEach(item => {
      const firstRow = item?.[0];
      const tenantId = firstRow?.tenantId;
      if (tenantId) {
        tenantIdsSet.add(tenantId);
      }
    });

    const tenantIds = [...tenantIdsSet].join(',');

    getDocConfig(tenantIds, 'PURCHASE_ORDER');
  }

  static getDerivedStateFromProps(props, state) {
    if (props.docConfigPO) {
      const configData = props.docConfigPO?.data?.find(item => item?.document_type === 'PURCHASE_ORDER_DOWNLOAD')?.configuration;

      const termsByTenant = {};
      for (const cfg of (configData || [])) {
        if (cfg?.tenant_id && cfg?.default_t_and_c !== undefined) {
          termsByTenant[cfg.tenant_id] = cfg.default_t_and_c;
        }
      }

      return {
        ...state,
        termsByTenant,
      };
    }
    return state;
  }

  /**
   * @param withApproval
   */

  getColumns(tenantSellerId, tenantDepartmentId) {
    const { isDataMaskingPolicyEnable, isHideCostPrice, cfPurchaseRequestLine, visibleColumns, cfPurchaseOrderLine, updateSellerInfo, isCarryForward, tenantSellerPRItems, user, } = this.props;
    const { actionType } = this.state;
    let updatedVisibleColumns
    const mergedArray = cfPurchaseOrderLine.map((orderLine) => {
      const requestLine = cfPurchaseRequestLine.find((request) => request.cfId === orderLine.cfId);
      return requestLine ? { ...orderLine, ...requestLine } : orderLine;
    });
    const isVendorOverseas = tenantSellerPRItems?.[tenantSellerId]?.[0]?.sellerInfo?.seller_type === 'OVERSEAS' && user?.tenant_info?.purchase_config?.sub_modules?.vendor?.settings?.hide_tax_for_overseas;
    updatedVisibleColumns = CustomFieldHelpers.updateVisibleColumns(CustomFieldHelpers.postCfStructure(mergedArray), visibleColumns);
    const columns = [
      {
        title: '',
        width: '60px',
        render: (text, record) => (
          record?.product_sku_info?.assets?.[0]?.url
            ? (
              <H3Image
                src={record?.product_sku_info?.assets[0].url}
                className="prod-table__image"
                style={{ width: '40px', height: '40px' }}
              />
            )
            : <H3Image src={imageDefault} className="prod-table__image prod-table__image__default" style={{ width: '40px', height: '40px' }} />
        ),
        visible: true,
        fixed: 'left',
      },
      {
        title: 'Product',
        render: (record) => <div>{record?.product_sku_name}</div>,
        visible: true,
        fixed: 'left',
      },
      {
        title: 'Quantity',
        render: (record) => <div>{`${QUANTITY(record?.quantity, record?.uom_info?.precision)} ${record?.uom_info?.uqc?.toProperCase() || ''}`}</div>,
        visible: true,

      },
      {
        title: 'Unit Price',
        render: (record) => ((isDataMaskingPolicyEnable && isHideCostPrice) ? <HideValue showPopOver popOverMessage={"You don't have access to unit price"} /> : this.props.MONEY(record?.unitPrice)),
        width: '12%',
        visible: true,
      },
      {
        title: 'Tax',
        render: (record) => `${record?.tax_value ? record?.tax_value : 0}%`,
        width: '10%',
        visible: isVendorOverseas ? false : true,
      },
      {
        title: 'Total',
        render: (record) => ((isDataMaskingPolicyEnable && isHideCostPrice) ? <HideValue showPopOver popOverMessage={"You don't have access to unit price"} /> : this.props.MONEY(this.getLineTotal(record) || '0')),
        visible: true,
        fixed: 'right',
      },

    ];

    if (cfPurchaseRequestLine?.length) {
      columns.splice(4, 0, ...CustomFieldHelpers.renderCustomLineColumns(false, mergedArray, updatedVisibleColumns, (value, key) => {
        updateSellerInfo(tenantSellerId, 'lineCustomFields', value, key, null, tenantDepartmentId);
      }, actionType, '', '', '', '', '', '', '', isCarryForward));
    }
    return columns.filter((item) => item.visible);
  }

  handleCreatePo(withApproval) {
    const { tenantSellerPRItems } = this.props;
    const {termsByTenant} =  this.state;
    const {
      user, createPurchaseOrder, history, selectedPurchaseRequest,
    } = this.props;

    this.setState({ formSubmitted: true });
    const cartItemGroup = Object.values(tenantSellerPRItems);
    const payload = [];
    const vendorAddressMandatory = user?.tenant_info?.purchase_config?.sub_modules?.purchase_order?.settings?.seller_address_required;

    for (let i = 0; i < cartItemGroup?.length; i++) {
      if (cartItemGroup?.[i]?.[0]?.checkedRecipients && !cartItemGroup?.[i]?.[0]?.email_id?.length) {
        notification.error({
          placement: 'top',
          message: 'Please enter email id of recipients',
          duration: 4,
        });
        return;
      }
      if (!cartItemGroup?.[i]?.[0]?.vendorAddress?.address_id && vendorAddressMandatory) {
        notification.error({
          placement: 'top',
          message: 'Please enter vendor address',
          duration: 4,
        });
        return;
      }
      if (!cartItemGroup?.[i]?.[0]?.billingAddress?.address_id) {
        notification.error({
          placement: 'top',
          message: 'Please enter billing address',
          duration: 4,
        });
        return;
      }
      const purchaseOrder = {};
      const tenantId = cartItemGroup?.[i]?.[0]?.tenantId || selectedPurchaseRequest?.tenant_id || user?.tenant_info?.tenant_id;
      purchaseOrder.remark = selectedPurchaseRequest?.remark;
      purchaseOrder.mrp_id = selectedPurchaseRequest?.mrp_id || null;
      purchaseOrder.attachments = selectedPurchaseRequest?.attachments;
      purchaseOrder.tenant_department_id = cartItemGroup?.[i]?.[0]?.tenantDepartmentId;
      purchaseOrder.tenant_seller_id = cartItemGroup?.[i]?.[0]?.sellerInfo?.tenant_seller_id;
      purchaseOrder.tenant_seller_info = {
        ...cartItemGroup?.[i]?.[0]?.tenantSellerInfo,
        gst_number: cartItemGroup?.[i]?.[0]?.gst_number,
      };
      purchaseOrder.tenant_id = tenantId;
      purchaseOrder.shipping_address_id = user?.user_tenants?.find((tenant) => tenant?.tenant_id === cartItemGroup?.[i]?.[0]?.tenantId)?.default_shipping_address_info?.address_id;
      purchaseOrder.billing_address_id = cartItemGroup?.[i]?.[0]?.billingAddress?.address_id;
      purchaseOrder.billing_address = cartItemGroup?.[i]?.[0]?.billingAddress;
      purchaseOrder.seller_address_id = cartItemGroup?.[i]?.[0]?.vendorAddress?.address_id;
      purchaseOrder.seller_address = cartItemGroup?.[i]?.[0]?.vendorAddress;
      purchaseOrder.payment_terms = [{
        advance_amount: 0,
        due_days: cartItemGroup?.[i]?.[0]?.payment_terms,
        remark: cartItemGroup?.[i]?.[0]?.remarks,
      }];
      purchaseOrder.po_date = dayjs(cartItemGroup?.[i]?.[0]?.po_date).format('YYYY/MM/DD');
      purchaseOrder.edd = dayjs(cartItemGroup?.[i]?.[0]?.delivery_date).format('YYYY/MM/DD');
      purchaseOrder.po_expiry_date = dayjs(cartItemGroup?.[i]?.[0]?.expiry_date);
      purchaseOrder.seq_id = cartItemGroup?.[i]?.[0]?.docSeqId;

      purchaseOrder.t_and_c = termsByTenant[tenantId] || '';

      purchaseOrder.ref_pr_ids = cartItemGroup?.[i]?.[0]?.purchase_requisition_id?.toString();
      purchaseOrder.status = withApproval ? 'ISSUED' : 'DRAFT';
      purchaseOrder.is_po_automatic_notification_enabled = cartItemGroup?.[i]?.[0]?.sendWhatsappNotification;
      purchaseOrder.notification_recipients = cartItemGroup?.[i]?.[0]?.email_id;
      purchaseOrder.is_automatic_notification_enabled = cartItemGroup?.[i]?.[0]?.checkedRecipients;
      purchaseOrder.custom_fields = CustomFieldHelpers.postCfStructure(cartItemGroup?.[i]?.[0]?.documentCustomFields);
      purchaseOrder.by_pass_tenant_product_validation = true;
      purchaseOrder.purchase_order_lines = cartItemGroup?.[i]?.map((item) => ({
        remark: item?.remark,
        product_sku_name: item?.product_sku_name,
        product_sku_id: item?.product_sku_info?.product_sku_id,
        offer_price: item?.unitPrice,
        quantity: item?.quantity,
        tax_id: item?.tax_id,
        uom_id: item?.uom_id,
        group_id: item?.group_id,
        uom_info: [item?.uom_info],
        tax_group_info: item?.taxInfo,
        pr_line_id: item?.pr_line_id,
        mo_line_id: item?.mo_line_id,
        custom_fields: CustomFieldHelpers.postCfStructure(item?.lineCustomFields),
      }));
      payload.push(purchaseOrder);
    }
    createPurchaseOrder(payload, () => {
      this.setState({ actionType: null, formSubmitted: false });
      history.push('/purchase/purchase-orders');
    }, false);
  }

  /**
   * @return
   * @param record
   */
  getLineTotal(record) {
    const {
      selectedPurchaseRequest,
    } = this.props;

    let total = 0;
    if (record?.quantity && record?.unitPrice && record?.taxInfo) {
      const taxableValue = record?.quantity * record?.unitPrice;
      total = Helpers.computeTaxation(taxableValue, record?.taxInfo, selectedPurchaseRequest?.tenant_info?.default_billing_address_info?.state, record?.sellerInfo?.state)?.taxed_value;
    }
    return total;
  }

  /**
   *
   * @return
   */

  render() {
    const {
      tenantSellerPRItems, createPurchaseOrderLoading, updateSellerInfo, user, isDataValidPO, isCarryForward,
    } = this.props;
    const {
      actionType, formSubmitted,
    } = this.state;

    const accountingGSTTransactionAsPerMaster = user?.tenant_info?.purchase_config?.sub_modules?.vendor?.settings?.gst_details_in_transaction === 'AS_PER_MASTER';

    const groupedData = {};
    const vendorAddressMandatory = user?.tenant_info?.purchase_config?.sub_modules?.purchase_order?.settings?.seller_address_required;

    Object.values(tenantSellerPRItems)?.forEach((item) => {
      const firstRow = item?.[0];
      const tenantId = firstRow?.tenantId;
      const tenantName = user?.user_tenants?.find((tenant) => tenant?.tenant_id === tenantId)?.tenant_name?.toUpperCase();
      const sellerId = firstRow?.sellerInfo?.tenant_seller_id;
      const sellerIdRowWise = firstRow?.sellerInfo?.seller_id;
      const sellerName = firstRow?.sellerInfo?.seller_name;
      const internalSlrCode = firstRow?.sellerInfo?.internal_slr_code;
      const departmentId = firstRow?.tenantDepartmentId;
      const departmentName = firstRow?.departmentName;

      // Create a combined key for sellerId and departmentId
      const sellerDepartmentKey = `${sellerId}-${departmentId}`;

      // Initialize tenant if it doesn't exist
      if (!groupedData[tenantId]) {
        groupedData[tenantId] = {
          tenant_name: tenantName,
          sellers: {},
        };
      }

      // Initialize seller and department if it doesn't exist
      if (!groupedData[tenantId].sellers[sellerDepartmentKey]) {
        groupedData[tenantId].sellers[sellerDepartmentKey] = {
          seller_name: sellerName,
          seller_id: sellerIdRowWise,
          internal_slr_code: internalSlrCode,
          department_name: departmentName,
          rows: [],
        };
      }

      // Push the item into the seller-department's rows array
      groupedData[tenantId].sellers[sellerDepartmentKey].rows.push(item);
    });

    return (
      <div className="pr-verify-container">
        <div className="pr-verify-container-heading">
          {Object.keys(tenantSellerPRItems)?.length}
          {' '}
          Purchase orders will be created as part of this order
        </div>
        {Object.entries(groupedData)?.map(([tenantId, tenantData]) => (
          <Fragment key={tenantId}>
            <Collapse
              bordered={false}
              defaultActiveKey={['1']}
              expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
            >
              <Panel
                header={(
                  <span style={{ color: '#2D7DF7', fontWeight: 600 }}>
                    {`${tenantData?.tenant_name}`}
                  </span>
                )}
                key={`tenant-${tenantId}`}>
                {Object.entries(tenantData?.sellers)?.map(([sellerDepartmentKey, sellerData]) => (
                  <Collapse
                    bordered={false}
                    defaultActiveKey={['1']}
                    expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
                    key={`seller-department-${sellerDepartmentKey}`}
                    style={{ padding: '0px' }}
                  >
                    <React.Fragment>
                      <Panel
                        header={(
                          <span style={{ color: '#2D7DF7', fontWeight: 600 }}>
                            {`${sellerData?.internal_slr_code} - ${sellerData?.seller_name} (${sellerData?.department_name})`}
                          </span>
                        )}
                        key={`seller-department-panel-${sellerDepartmentKey}`}
                        className="seller-department-panel"
                      >
                        {sellerData?.rows.map((row, index) => (
                          <div key={index} className="seller-department-panel-form">
                            <Table
                              title={() => (
                                <div className="pr-verify-title">
                                  <div className="ant-row">
                                    <DocumentNumberSeqInput
                                      valueFromProps={row?.[0]?.poNumber}
                                      setInitialDocSeqNumber={(value) => { }}
                                      entityName="PURCHASE_ORDER"
                                      docSeqId={row?.[0]?.docSeqId}
                                      tenantId={tenantId}
                                      onChangeFromProps={(event, newValue, seqId) => {
                                        const seqNumber = {
                                          poNumber: newValue ? (newValue || '') : (event?.target?.value || ''),
                                          seqId: seqId,
                                        }
                                        updateSellerInfo(row?.[0]?.tenantSellerInfo?.tenant_seller_id, 'poNumber', seqNumber, null, null, row?.[0]?.tenantDepartmentId);
                                      }}
                                      docTitle="Purchase Order#"
                                      rowClassName='ant-col-md-8'
                                      inputRowClassName="create-po__input-row"
                                      inputWrapperClassName="create-po__input-row__input"
                                      labelClassName="create-po__input-row__label"
                                      seqClassName='sqn__selector'
                                      prefixRequiredOnly
                                    />
                                    <div className="ant-col-md-8">
                                      <div className="create-po__input-row">
                                        <H3Text
                                          text="GST Number"
                                          className="create-po__input-row__label"
                                        />
                                        <H3FormInput
                                          name="GST Number"
                                          type="text"
                                          disabled={createPurchaseOrderLoading || accountingGSTTransactionAsPerMaster}
                                          containerClassName="orgInputContainer create-po__input-row__input"
                                          labelClassName="orgFormLabel"
                                          inputClassName="orgFormInput input"
                                          placeholder=""
                                          onChange={(event) => updateSellerInfo(row?.[0]?.tenantSellerInfo?.tenant_seller_id, 'gst_number', event?.target?.value, null, null, row?.[0]?.tenantDepartmentId)}
                                          value={row?.[0]?.gst_number}
                                        />
                                      </div>
                                    </div>
                                    <div className="ant-col-md-8">
                                      <div className="create-po__input-row">
                                        <div className="create-po__input-row__label">
                                          PO Date
                                          <span style={{ color: 'red' }}>{'  *'}</span>
                                        </div>
                                        <div className="create-po__input-row__input">
                                          <DatePicker
                                            value={dayjs(row?.[0]?.po_date)}
                                            allowClear={false}
                                            onChange={(value) => updateSellerInfo(row?.[0]?.tenantSellerInfo?.tenant_seller_id, 'po_date', value, null, null, row?.[0]?.tenantDepartmentId)}
                                            format="DD-MM-YYYY"
                                            style={{
                                              border: '1px solid rgba(68, 130, 218, 0.2)',
                                              borderRadius: '2px',
                                              height: '28px',
                                              padding: '1px 7px',
                                              width: '100%',
                                              background: 'white',
                                              marginBottom:
                                                row?.[0]?.po_date ? '10px' : '0px',
                                            }}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="ant-col-md-8">
                                      <div className="create-po__input-row">
                                        <H3Text
                                          text="Delivery Date"
                                          className="create-po__input-row__label"
                                        // required={deliveryDateMandatory}
                                        />
                                        <div className="create-po__input-row__input">
                                          <DatePicker
                                            value={dayjs(row?.[0]?.delivery_date)}
                                            allowClear={false}
                                            onChange={(value) => updateSellerInfo(row?.[0]?.tenantSellerInfo?.tenant_seller_id, 'delivery_date', value, null, null, row?.[0]?.tenantDepartmentId)}
                                            format="DD-MM-YYYY"
                                            style={{
                                              border: '1px solid rgba(68, 130, 218, 0.2)',
                                              borderRadius: '2px',
                                              height: '28px',
                                              padding: '1px 7px',
                                              width: '100%',
                                              background: 'white',
                                              marginBottom: row?.[0]?.delivery_date ? '10px' : '0px',
                                            }}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="ant-col-md-8">
                                      <div className="create-po__input-row">
                                        <H3Text text="Expiry Date" className="create-po__input-row__label" />
                                        <div className="create-po__input-row__input">
                                          <DatePicker
                                            allowClear={false}
                                            value={dayjs(row?.[0]?.expiry_date)}
                                            onChange={(value) => updateSellerInfo(row?.[0]?.tenantSellerInfo?.tenant_seller_id, 'expiry_date', value, null, null, row?.[0]?.tenantDepartmentId)}
                                            format="DD-MM-YYYY"
                                            style={{
                                              border: '1px solid rgba(68, 130, 218, 0.2)',
                                              borderRadius: '2px',
                                              height: '28px',
                                              padding: '1px 7px',
                                              width: '100%',
                                              background: 'white',
                                              marginBottom: '10px',
                                            }}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="ant-col-md-8">
                                      <SelectPaymentTerm
                                        selectedPaymentTerm={row?.[0]?.payment_terms}
                                        onChange={(value) => {
                                          // this.setState({ paymentTerms: value?.due_days });
                                          updateSellerInfo(row?.[0]?.tenantSellerInfo?.tenant_seller_id, 'payment_terms', value?.due_days, null, null, row?.[0]?.tenantDepartmentId);
                                        }}
                                        callback={(value) => {
                                          updateSellerInfo(row?.[0]?.tenantSellerInfo?.tenant_seller_id, 'payment_terms', Number(value), null, null, row?.[0]?.tenantDepartmentId);
                                        }}
                                        containerClassName="orgInputContainer create-po__input-row"
                                        inputClassName=" create-po-seller__selector create-po__input-row__input"
                                        labelClassName="create-po__input-row__label"
                                        showError={!row?.[0]?.payment_terms}
                                        disabled={
                                          createPurchaseOrderLoading
                                        }
                                        showAddPaymentTerm
                                        placeholder="Select Payment Term"
                                      />
                                    </div>
                                    <div className="ant-col-md-8">
                                      <div className="create-po__input-row" style={{ marginTop: '4px' }}>
                                        <H3Text text="Payment remarks(optional)" className="create-po__input-row__label" />
                                        <H3FormInput
                                          name="payment terms remarks"
                                          type="text"
                                          containerClassName="orgInputContainer create-po__input-row__input"
                                          labelClassName="orgFormLabel"
                                          inputClassName="orgFormInput input"
                                          onChange={(event) => {
                                            updateSellerInfo(row?.[0]?.tenantSellerInfo?.tenant_seller_id, 'remarks', event.target.value, null, null, row?.[0]?.tenantDepartmentId);
                                          }}
                                          maxlength="100"
                                          value={row?.[0]?.remarks}
                                          disabled={
                                            createPurchaseOrderLoading
                                          }
                                        />
                                      </div>
                                    </div>
                                    <CustomFieldV3
                                      customFields={row?.[0]?.documentCustomFields}
                                      formSubmitted={actionType}
                                      customInputChange={(value, cfId) => updateSellerInfo(row?.[0]?.tenantSellerInfo?.tenant_seller_id, 'documentCustomFields', value, null, cfId, row?.[0]?.tenantDepartmentId)}
                                      wrapperClassName="ant-col-md-8"
                                      containerClassName="orgInputContainer create-po__input-row__input"
                                      inputClassName="orgFormInput input"
                                      labelClassName="create-po__input-row__label"
                                      errorClassName="form__input-row__input-error"
                                      disableCase={
                                        createPurchaseOrderLoading
                                      }
                                      hideTitle
                                      isCarryForward={isCarryForward}
                                    />
                                  </div>
                                  <div
                                    className="form__wrapper"
                                    style={{ padding: '0px' }}
                                  >
                                    <div className="form__section">
                                      <div className="form__section-inputs">
                                        <div className="ant-row">
                                          <div className="ant-col-md-12">
                                            <div className="form__input-row">
                                              <H3Text
                                                text="Vendor's Address"
                                                className="create-po__input-row__label"
                                                required={vendorAddressMandatory}
                                              />
                                              <div className={`form__input-row__address__wrapper ${(formSubmitted && vendorAddressMandatory && !row?.[0]?.vendorAddress) ? 'form__input-row__address-error' : ''}`}>
                                                <div className="form__input-row__address">
                                                  {row?.[0]?.vendorAddress && (
                                                    <div className="form__input-row__address-info"
                                                      style={{
                                                        color: "rgb(58, 58, 58)"
                                                      }}
                                                    >
                                                      <div className="form__input-row__address-l1">
                                                        {row?.[0]?.vendorAddress?.address1}
                                                      </div>
                                                      <div className="form__input-row__address-l2">
                                                        {`${row?.[0]?.vendorAddress?.city}, ${row?.[0]?.vendorAddress?.state}, ${row?.[0]?.vendorAddress?.postal_code}, ${row?.[0]?.vendorAddress?.country}`}
                                                      </div>
                                                    </div>
                                                  )}
                                                  {!row?.[0]?.vendorAddress && (
                                                    <H3Text
                                                      text="Select address.."
                                                      className="form__input-row__address-placeholder"
                                                    />
                                                  )}
                                                  <div
                                                    className="form__input-row__address-icon"
                                                    onClick={() => {
                                                      updateSellerInfo(row?.[0]?.tenantSellerInfo?.tenant_seller_id, 'selectedAddressType', 'SELLER', null, null, row?.[0]?.tenantDepartmentId);
                                                    }}
                                                  >
                                                    <EditFilled />
                                                    {' '}
                                                    Update
                                                  </div>
                                                </div>
                                                {formSubmitted && !row?.[0]?.vendorAddress && vendorAddressMandatory && (
                                                  <div className="input-error">
                                                    *Please select vendor address
                                                  </div>
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                          <div className="ant-col-md-12">
                                            <div className="form__input-row">
                                              <H3Text
                                                text="Billing Address"
                                                className="create-po__input-row__label"
                                                required
                                              />
                                              <div className={`form__input-row__address__wrapper ${(formSubmitted && !row?.[0]?.billingAddress) ? 'form__input-row__address-error' : ''}`}>
                                                <div className="form__input-row__address">
                                                  {row?.[0]?.billingAddress && (
                                                    <div className="form__input-row__address-info"
                                                      style={{
                                                        color: "rgb(58, 58, 58)"
                                                      }}
                                                    >
                                                      <div className="form__input-row__address-l1">
                                                        {row?.[0]?.billingAddress?.address1}
                                                      </div>
                                                      <div className="form__input-row__address-l2">
                                                        {`${row?.[0]?.billingAddress?.city}, ${row?.[0]?.billingAddress?.state}, ${row?.[0]?.billingAddress?.postal_code}, ${row?.[0]?.billingAddress?.country}`}
                                                      </div>
                                                    </div>
                                                  )}
                                                  {!row?.[0]?.billingAddress && (
                                                    <H3Text
                                                      text="Select address.."
                                                      className="form__input-row__address-placeholder"
                                                    />
                                                  )}
                                                  <div
                                                    className="form__input-row__address-icon"
                                                    onClick={() => {
                                                      updateSellerInfo(row?.[0]?.tenantSellerInfo?.tenant_seller_id, 'selectedAddressType', 'TENANT_BILLING', null, null, row?.[0]?.tenantDepartmentId);
                                                    }}
                                                  >
                                                    <EditFilled />
                                                    {' '}
                                                    Update
                                                  </div>
                                                </div>
                                                {formSubmitted && !row?.[0]?.billingAddress && (
                                                  <div className="input-error">
                                                    *Please select billing address
                                                  </div>
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                          <div className="ant-col-md-24">
                                            {user?.tenant_info?.integration_config?.sub_modules?.whatsapp?.is_active && (
                                              <div className="form__input-row" style={{ marginTop: '10px' }}>
                                                <Checkbox
                                                  checked={row?.[0]?.sendWhatsappNotification}
                                                  onChange={() => {
                                                    updateSellerInfo(row?.[0]?.tenantSellerInfo?.tenant_seller_id, 'sendWhatsappNotification', !row?.[0]?.sendWhatsappNotification, null, null, row?.[0]?.tenantDepartmentId);
                                                  }}
                                                />
                                                <span
                                                  style={{
                                                    fontWeight: '500',
                                                    fontSize: '12px',
                                                    marginLeft: '5px',
                                                    color: ' rgb(58, 58, 58)',
                                                  }}
                                                >
                                                  Send automatic whatsapp message when order is Issued
                                                </span>
                                              </div>
                                            )}
                                          </div>
                                          <div className="ant-col-md-24">
                                            <div className="create-po__input-row__input">
                                              <div>
                                                <Checkbox
                                                  checked={row?.[0]?.checkedRecipients}
                                                  onChange={() => {
                                                    updateSellerInfo(row?.[0]?.tenantSellerInfo?.tenant_seller_id, 'checkedRecipients', !row?.[0]?.checkedRecipients, null, null, row?.[0]?.tenantDepartmentId);
                                                  }}
                                                />
                                                <span
                                                  style={{
                                                    fontWeight: '500',
                                                    fontSize: '12px',
                                                    marginLeft: '5px',
                                                    color: ' rgb(58, 58, 58)',
                                                    marginBottom: '10px',
                                                  }}
                                                >
                                                  Send automatic email when order is issued
                                                </span>
                                              </div>
                                              {row?.[0]?.checkedRecipients && (
                                                <div>
                                                  <PRZSelect
                                                    mode="tags"
                                                    value={row?.[0]?.email_id}
                                                    filterOption={false}
                                                    maxTagCount="responsive"
                                                    onChange={(value) => {
                                                      const recipients = [];
                                                      for (let i = 0; i < value?.length; i++) {
                                                        if (Helpers.validateEmail(value[i])) {
                                                          recipients.push(value[i]);
                                                        }
                                                      }
                                                      updateSellerInfo(row?.[0]?.tenantSellerInfo?.tenant_seller_id, 'email_id', recipients, null, null, row?.[0]?.tenantDepartmentId);
                                                    }}
                                                    className={`create-po__input-row__input__email-input ${formSubmitted && !row?.[0]?.email_id?.length > 0 ? 'prz-select__error-border' : ''}`}
                                                    style={{
                                                      width: '51%',
                                                      fontSize: '13px',
                                                    }}
                                                    placeholder=""
                                                  />
                                                </div>
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                              columns={this.getColumns(row?.[0]?.tenantSellerId, row?.[0]?.tenantDepartmentId)}
                              size="small"
                              dataSource={row}
                              key={row?.[0]?.sellerInfo?.seller_id}
                              pagination={false}
                              scroll={{ x: 'max-content' }}
                            />
                            <Drawer
                              open={row?.[0]?.showAddressDrawer}
                              onClose={(event) => updateSellerInfo(row?.[0]?.tenantSellerInfo?.tenant_seller_id, 'showAddressDrawer', false, null, null, row?.[0]?.tenantDepartmentId)}
                              width="360"
                              destroyOnClose
                            >
                              <AddressSelector
                                title={row?.[0]?.selectedAddressType === 'TENANT_BILLING' ? "Billing Address" : 'Vendor Address'}
                                addressType={row?.[0]?.selectedAddressType?.split('_')[0]}
                                selectedAddressId={row?.[0]?.selectedAddressType === 'TENANT_BILLING' ? row?.[0]?.billingAddress?.address_id : row?.[0]?.vendorAddress?.address_id}
                                onAddressChange={(address) => {
                                  if (row?.[0]?.selectedAddressType === 'TENANT_BILLING') {
                                    updateSellerInfo(row?.[0]?.tenantSellerInfo?.tenant_seller_id, 'billingAddress', address, null, null, row?.[0]?.tenantDepartmentId)
                                  } else {
                                    updateSellerInfo(row?.[0]?.tenantSellerInfo?.tenant_seller_id, 'vendorAddress', address, null, null, row?.[0]?.tenantDepartmentId)
                                  }
                                }}
                                entityId={row?.[0]?.selectedAddressType === 'TENANT_BILLING' ? tenantId : sellerData?.seller_id}
                                entityType={row?.[0]?.selectedAddressType === 'SELLER' ? 'SELLER' : 'TENANT'}
                                seller={sellerData}
                                tenantId={tenantId}
                              />
                            </Drawer>
                          </div>
                        ))}
                      </Panel>
                    </React.Fragment>
                  </Collapse>
                ))}
              </Panel>
            </Collapse>
          </Fragment>
        ))}
        <div className="custom-drawer__footer" style={{ width: 'calc(100% - 60px)' }}>
          <Button
            type="primary"
            onClick={() => {
              this.setState({ actionType: 'DRAFT' });
              if (isDataValidPO()) {
                this.handleCreatePo(false);
              }
            }}
            style={{ width: '150px' }}
            disabled={createPurchaseOrderLoading}
          >
            {(createPurchaseOrderLoading && actionType === 'DRAFT') ? <LoadingOutlined /> : 'Save as Draft'}
          </Button>
          <Button
            type="primary"
            onClick={() => {
              this.setState({ actionType: 'ISSUED' });
              if (isDataValidPO()) {
                this.handleCreatePo(true);
              }
            }}
            style={{ width: '150px', marginLeft: '10px' }}
            disabled={createPurchaseOrderLoading}
          >
            {(createPurchaseOrderLoading && actionType === 'ISSUED') ? <LoadingOutlined /> : 'Save and Issue'}
          </Button>
        </div>
      </div>
    );
  }
}
const mapStateToProps = ({
  UserReducers, PurchaseOrderReducers, TenantReducers, DocConfigReducers, GetDocSequence,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  createPurchaseOrderLoading: PurchaseOrderReducers.createPurchaseOrderLoading,
  tenantsConfiguration: TenantReducers.tenantsConfiguration,
  priceMasking: UserReducers.priceMasking,
  docConfigPO: DocConfigReducers.docConfigPO,
  getDocConfigPOLoading: DocConfigReducers.getDocConfigPOLoading,
  documentSequence: GetDocSequence.data,
});

const mapDispatchToProps = (dispatch) => ({
  createPurchaseOrder: (payload, callback, withApproval) => dispatch(PurchaseOrderActions.createPurchaseOrder(payload, callback, withApproval)),
  getDocConfig: (tenantId, entityName, callback) => dispatch(DocConfigActions.getDocConfig(tenantId, entityName, callback)),
});

PRVerifyPurchaseOrders.propTypes = {
  user: PropTypes.any,
  createPurchaseOrder: PropTypes.func,
  createPurchaseOrderLoading: PropTypes.bool,
  tenantSellerPRItems: PropTypes.any,
  history: PropTypes.func,
  tenantsConfiguration: PropTypes.any,
  selectedPurchaseRequest: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PRVerifyPurchaseOrders));
